import { pathOr } from 'ramda';
import { usePromotionsStore } from '../../store';

export const selectTournamentServiceTournamentInfo = (id: string | number) =>
  pathOr({}, ['tournaments', id]);

export const useGetTournamentServiceTournamentInfo = (id: string | number) =>
  usePromotionsStore(selectTournamentServiceTournamentInfo(id));
